import MobileNumberInput from "../MobileNumberInput";
import CustomDateRangePicker from "../DateRangePicker";
import Datepicker from "../Datepicker";
import SelectDropdown from "../SelectDropdown";
import { prepareSelectData } from "../../utils/commonHelper";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";


export const ProductParameterForm = ({
  formData,
  handleInputChange,
  handleRangeChange,
  item,
  disabled = false,
  currentLanguage,
  errorMessages = '',
  defaultValue
}) => {
  const { t, i18n } = useTranslation();
  switch (item?.input_type) {
    case "mobile-number-input":
      return (
        <MobileNumberInput
          selectedCountryCode={formData["selectedCountryCode"]}
          enteredMobileNumber={
            formData[item?.input_label?.replace(/\s+/g, "_").toLowerCase()]
          }
          placeHolder={t(item?.input_label?.replace(/\s+/g, "_").toLowerCase())}
          getMobileNumber={(number) => {
            handleInputChange("selectedCountryCode", number?.countryCode);
            handleInputChange(
              item?.input_label?.replace(/\s+/g, "_").toLowerCase(),
              number?.number
            );
          }}
        />
      );
    case "date-range":
      return (
        <CustomDateRangePicker
          name={item?.input_label?.replace(/\s+/g, "_").toLowerCase() || ""}
          customPlaceHolder={t(item?.input_label?.replace(/\s+/g, "_").toLowerCase())}
          onChange={handleRangeChange}
          required={item?.is_mandatory === "1"}
        />
      );
    case "date":
      return (
        <Datepicker
          name={item?.input_label?.replace(/\s+/g, "_").toLowerCase() || ""}
          placeHolder={t(item?.input_label?.replace(/\s+/g, "_").toLowerCase())}
          onChange={handleInputChange}
          value={
            formData[item?.input_label?.replace(/\s+/g, "_").toLowerCase()]
          }
          required={item?.is_mandatory === "1"}
          minDate={
            item?.input_label === "End Date"
              ? formData["start_date"]
              : new Date()
          }
        />
      );
    case "radio":
      return (
        item?.option_paremeter?.length > 0 && (
          <>
            {item?.option_paremeter.map((option, index) => (
              <div
                className="form-check form-check-inline"
                key={`${item?.input_label}_${option?.option_label}_${index}`}
              >
                <input
                  type="radio"
                  id={option?.option_label}
                  name={
                    item?.input_label?.replace(/\s+/g, "_").toLowerCase() || ""
                  }
                  value={option?.option_value}
                  className="form-check-input"
                  onChange={(e) =>
                    handleInputChange(e.target.name, e.target.value)
                  }
                />
                <label
                  htmlFor={option?.option_label}
                  className="form-check-label"
                >
                  {option?.option_label}
                </label>
              </div>
            ))}
          </>
        )
      );
    case "select":
      return (
        <SelectDropdown
          name={item?.input_label?.replace(/\s+/g, "_").toLowerCase() || ""}
          placeholder={t(item?.input_label?.replace(/\s+/g, "_").toLowerCase())}

          options={
            item?.country_master && item?.country_master?.length
              ? prepareSelectData(
                item?.country_master,
                item?.option_paremeter?.length
                  ? item?.option_paremeter[0]["option_type"]
                  : "country",
                currentLanguage
              )
              : prepareSelectData(item?.option_paremeter, null, currentLanguage)
          }
          handleOnChange={handleInputChange}
          required={item?.is_mandatory === "1"}
          isSearchable={true}
          defaultValue={{
            value:
              formData[
              item?.input_label?.replace(/\s+/g, "_").toLowerCase() ||
              undefined
              ] || "",
            label:
              formData[
              item?.input_label?.replace(/\s+/g, "_").toLowerCase() ||
              undefined
              ] || item?.input_label,
          }}
          errorMessage={errorMessages[item?.input_label?.replace(/\s+/g, "_").toLowerCase()] ? errorMessages[item?.input_label?.replace(/\s+/g, "_").toLowerCase()] : ''}
        />
      );
    default: {
      const fieldKey = item?.input_label?.replace(/\s+/g, "_").toLowerCase() || "";
      const fieldError = errorMessages?.[fieldKey] || "";
      const isNumericField =
        item?.input_label?.includes("Seniors") ||
        (item?.input_label?.includes("Adults") && item?.input_label?.includes("18 or Above")) ||
        item?.input_label?.includes("Child");

      const handleNumericKeyDown = (e) => {
        // Allow: backspace, delete, tab, escape, enter, arrows
        const allowedKeys = ["Backspace", "Delete", "Tab", "Escape", "Enter", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End"];
        if (allowedKeys.includes(e.key)) return;
        // Allow Ctrl/Cmd + A, C, V, X
        if ((e.ctrlKey || e.metaKey) && ["a", "c", "v", "x"].includes(e.key.toLowerCase())) return;
        // Block anything that's not a digit
        if (!/^\d$/.test(e.key)) {
          e.preventDefault();
        }
      };

      const handleNumericPaste = (e) => {
        const pastedData = e.clipboardData.getData("text");
        if (!/^\d+$/.test(pastedData)) {
          e.preventDefault();
        }
      };

      return (
        <>
          <input
            type={item?.input_type}
            disabled={disabled}
            name={fieldKey}
            placeholder={t(fieldKey)}
            className={`form-control element-style ${fieldError ? "is-invalid" : ""}`}
            onChange={(e) => handleInputChange(e.target.name, e.target.value)}
            onKeyDown={isNumericField ? handleNumericKeyDown : undefined}
            onPaste={isNumericField ? handleNumericPaste : undefined}
            required={item?.is_mandatory === "1"}
            defaultValue={
              formData[fieldKey || undefined]
            }
          />
          {fieldError && <div className="invalid-feedback d-block">{fieldError}</div>}
        </>
      );
    }
  }
};
